// extracted by mini-css-extract-plugin
module.exports = {"lineBorder":"Title_lineBorder__3c89w","white":"Title_white__-vWIh","smallTitle":"Title_smallTitle__8IhH9"};